import Typography from '@mui/material/Typography'
import { BorderContainer } from '../borderedContainer'

export const Unknown = () => (
  <BorderContainer aria-label="unknown" gap={1}>
    <Typography variant="body1" fontWeight={600}>
      Unsupported country
    </Typography>
    <Typography variant="body2" color="text.secondary">
      Creating mandates is not supported for this customer
    </Typography>
  </BorderContainer>
)
